import {
  RequestStatusApproved,
  RequestStatusCancellationApproved,
  RequestStatusCancellationDeclined,
  RequestStatusCancelled,
  RequestStatusDeclined,
  RequestStatusHasNoPolicyNo,
  RequestStatusModificationApproved,
  RequestStatusModificationDeclined,
  RequestStatusPriceApproved,
  RequestStatusPriceDeclined,
  RequestStatusPriceSet,
  RequestStatusProcessing,
  RequestStatusRefund,
  RequestStatusWaitingForCancellation,
  RequestStatusWaitingForEditing,
  RequestStatusWaitingForPrice,
} from "./RequestStatuses";
import { OfflineStorage } from "./estrylib";

export const InsuranceRequestStatuses = [
  {
    label: window.sys_app_translate(
      "All Statuses",
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: "All",
  },
  {
    label: window.sys_app_translate(
      RequestStatusApproved,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusApproved,
  },
  {
    label: window.sys_app_translate(
      RequestStatusDeclined,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusDeclined,
  },
  {
    label: window.sys_app_translate(
      RequestStatusRefund,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusRefund,
  },
  {
    label: window.sys_app_translate(
      RequestStatusCancelled,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusCancelled,
  },
  {
    label: window.sys_app_translate(
      RequestStatusProcessing,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusProcessing,
  },
  {
    label: window.sys_app_translate(
      RequestStatusModificationApproved,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusModificationApproved,
  },
  {
    label: window.sys_app_translate(
      RequestStatusCancellationDeclined,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusCancellationDeclined,
  },
  {
    label: window.sys_app_translate(
      RequestStatusModificationDeclined,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusModificationDeclined,
  },
  {
    label: window.sys_app_translate(
      RequestStatusCancellationApproved,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusCancellationApproved,
  },
  {
    label: window.sys_app_translate(
      RequestStatusWaitingForCancellation,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusWaitingForCancellation,
  },
  {
    label: window.sys_app_translate(
      RequestStatusWaitingForEditing,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusWaitingForEditing,
  },
  {
    label: window.sys_app_translate(
      RequestStatusPriceSet,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusPriceSet,
  },
  {
    label: window.sys_app_translate(
      RequestStatusPriceApproved,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusPriceApproved,
  },
  {
    label: window.sys_app_translate(
      RequestStatusPriceDeclined,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusPriceDeclined,
  },
  {
    label: window.sys_app_translate(
      RequestStatusWaitingForPrice,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusWaitingForPrice,
  },
  {
    label: window.sys_app_translate(
      RequestStatusHasNoPolicyNo,
      OfflineStorage.instance.get("esitqapp-lang")
    ),
    value: RequestStatusHasNoPolicyNo,
  },
];
